module.exports = __webpack_public_path__ + "static/img/4.c009854.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/TheMolding/4.jpg
// module id = buFo
// module chunks = 1